// extracted by mini-css-extract-plugin
module.exports = {"filter-wrapper":"GeneralFilter__filter-wrapper__3KJkA"};